import { useRecipient } from '../RecipientProvider'
import { useCoSUsers } from '@g4g/graphql/src/shop/queries'
import type { GetUsers_getUsers } from '@g4g/graphql/src/shop/__generated__/GetUsers'

/**
 * Get all the MoMi Users info for selected recipient
 * or previously selected recipients
 */
export default function useRecipientUsers() {
  const { currentRecipient, recentRecipients } = useRecipient()
  const { data, loading, error } = useCoSUsers({
    input: {
      cosIds: [
        ...(currentRecipient ? [currentRecipient] : []),
        ...recentRecipients.filter((r) => r !== currentRecipient),
      ],
    },
  })
  const users = data?.getUsers ? data.getUsers : undefined

  return {
    currentRecipient: users?.find((u) => u.cosId === currentRecipient),
    // Sort the response data by the recentRecipients array
    // so that we keep the most recent at the top even after we
    // query the user data
    recentRecipients: users
      ? recentRecipients
          .map((cosId) => users.find((u) => u.cosId === cosId))
          .filter((item): item is GetUsers_getUsers => !!item)
      : undefined,
    loading,
    error,
  }
}
